<p-tabs value="{{activeTabIndex}}">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Vista Previa</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(2)" value="2">Consulta Detalle</p-tab>
    <!-- Se comenta para evitar inconvenientes al crear formatos sin configuracion de html -->
    <!-- <app-custom-button class="widthBtns" [title]="'Nuevo Registro'" [label]="'Nuevo'" [severity]="'success'"
      (onClick)="createNewFormat()"></app-custom-button> -->
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-preview-format></app-preview-format>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'format'"
        (onRecoverData)="getFormatsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'format'"
        (onRecoverData)="getFormatDetailsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>